
import _ from 'lodash';

const namespaced = true;

const state = {
  list: [],
  clients: [],
  sites: [],
  page: 1,
  label: ``,
  maker: null,
  client: null,
  site: null,
};

const mutations = {
  SET_LIST(state, list) {
    // list = state.list;
    state.list = list;
  },
  SET_CLIENTS(state, clients) {
    state.clients = clients;
  },
  SET_SITES(state, sites) {
    state.sites = sites;
  },
  SET_PAGE(state, page) {
    state.page = page;
  },
  SET_LABEL(state, label) {
    state.label = label;
  },
  SET_MAKER(state, maker) {
    state.maker = maker;
  },
  SET_CLIENT(state, client) {
    state.client = client;
  },
  SET_SITE(state, site) {
    state.site = site;
  },
};

const actions = {
  async fetchClients({ commit, dispatch }) {
    commit(`SET_CLIENTS`, []);
    const clients = await dispatch(`model/client/fetchClients`, null, { root: true });

    commit(`SET_CLIENTS`, clients);
    return clients;
  },
  async fetchSites({ commit, dispatch }, clientId) {
    commit(`SET_SITES`, []);
    const sites = await dispatch(`model/site/fetchSites`, clientId, { root: true });

    commit(`SET_SITES`, sites);
    return sites;
  },
  async fetchList({ state, commit, dispatch }) {
    const queryParams = {
      page: state.page,
    };

    if (state.label && _.trim(state.label).length) { queryParams.label = state.label; }
    if (state.maker) { queryParams.maker = state.maker; }
    if (state.client) { queryParams.client = state.client; }
    if (state.site) { queryParams.site = state.site; }

    const equipments = await dispatch(`model/equipment/fetchList`, {
      queryParams,
    }, { root: true });
    commit(`SET_LIST`, equipments);
  },
  forceFetchList({ dispatch }) {
    return dispatch(`fetchList`);
  },
  async updateEquipmentLocally({ state, commit }, equipment) {
    const equipmentIndex = _.findIndex(state.list, { id: equipment.id });
    if (equipment !== -1) {
      state.list[equipmentIndex] = equipment;
      commit(`SET_LIST`, _.clone(state.list));
    }
  },
  async removeEquipmentLocally({ state, commit }, equipment) {
    const equipmentIndex = _.findIndex(state.list, { id: equipment.id });
    if (equipment !== -1) {
      state.list.splice(equipmentIndex, 1);
      commit(`SET_LIST`, _.clone(state.list));
    }
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
